
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CompanyRegistrationState {
  isSameBranch: boolean;
  claimedCompanyData: any | null;
  userRegisteredCompanyData: any | null;
  mappedBranchesData: any; 
}

const initialState: CompanyRegistrationState = {
  isSameBranch: false,
  claimedCompanyData: null,
  userRegisteredCompanyData: null,
  mappedBranchesData: [],
};

const companyRegistrationSlice = createSlice({
  name: 'companyRegistration',
  initialState,
  reducers: {
    setIsSameBranch(state, action: PayloadAction<boolean>) {
      state.isSameBranch = action.payload;
    },
    setClaimedCompanyData(state, action: PayloadAction<any>) {
      state.claimedCompanyData = action.payload;
    },
    setUserRegisteredCompanyData(state, action: PayloadAction<any>) {
      state.userRegisteredCompanyData = action.payload;
    },
    setMappedBranchesData(state, action: PayloadAction<any[]>) {
      state.mappedBranchesData = action.payload;
    },
    resetCompanyRegistration(state) {
      state.claimedCompanyData = null;
      state.userRegisteredCompanyData = null;
      state.mappedBranchesData = [];
    }
  },
});

export const {
  setIsSameBranch,
  setClaimedCompanyData,
  setUserRegisteredCompanyData,
  setMappedBranchesData,
  resetCompanyRegistration,
} = companyRegistrationSlice.actions;

export default companyRegistrationSlice.reducer;
